import FileSaver from "file-saver";
import { metricValueFormat } from "../../utils/metricValueFormat";
import { AgentMetricMetColor, Numbers } from "../../utils/typeConstants";
import { ROLES } from "../../constants";

export const colorCode = (metricAttained: number) => {
    if (metricAttained === Numbers.ONE) return AgentMetricMetColor.METRIC_MET1;
    else if (metricAttained === Numbers.TWO) return AgentMetricMetColor.METRIC_MET2;
    else if (metricAttained === Numbers.THREE) return AgentMetricMetColor.METRIC_MET3;
    else if (metricAttained === Numbers.FOUR) return AgentMetricMetColor.METRIC_MET4;
    else if (metricAttained === Numbers.FIVE) return AgentMetricMetColor.METRIC_MET5;
    else return AgentMetricMetColor.METRIC_MET5;
};
const expAgent = (agents:any,metricColHeader:any) => {
    const expAge = [{}];
    for (let i = 0; i < agents.length; i++) {
        const agent = agents[i];
        let arr = [];
        arr = metricColHeader.map((x: any) => {
            let y = x;
            y = y.replaceAll(' - ', '_');
            let metricValue = agent.agentMetrics[0]?.metricsDetails[x]?.metric_value;
            const metricTypeName = agent.agentMetrics[0]?.metricsDetails[x]?.metric_type_name;
            if (metricValue === undefined || metricValue === null) {
                metricValue = '--';
            }
            else if (metricTypeName !== undefined) {
                metricValue = metricValueFormat(metricValue, metricTypeName);
            }
            return { [y]: metricValue };
        });

        expAge.push({
            'Oracle Id': `${agent.agent_number}`,
            Employee: `${agent.agent_name}`,
            "Employee Role": ROLES.Agents.includes(agent.manager_level) ? 'Agent': 'Team Lead',
            Metrics_Met: `${agent.total_metrics_attained}`,
        });
        arr.map((x: any) => {
            return Object.assign(expAge[i + 1], x);
        });
    }
    return expAge;
};

export const exportExcel = (agents: any,metricColHeader: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(expAgent(agents,metricColHeader));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'agents');
    });
};

const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};